(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["anewall_instagram-feed"] && !Shopify.designMode) return;
  try {
    
  $( document ).ready(function() {
    
     function resizeInstagram(){
      var insta = $('.single-instagram-post');
      var instaWidth = insta.width();
      insta.height(instaWidth);
      console.log(insta);
      console.log(instaWidth);
    }

  $(window).load(function(){

    resizeInstagram();

  });

     var feed = new Instafeed({
         userId: '329805308',
         get: 'user',
         clientId: ' 78bdb0141442433d82e1b6b2eae44506',
         accessToken: '329805308.1677ed0.27cbd868ebcb45679aa6bc9e5dd7776d',
         limit: 4, 
         resolution: "standard_resolution",
         template: '<div class="grid__item xs--one-half small--one-half medium--one-quarter large--one-quarter single-post-wrapper"><a class="single-instagram-post {{orientation}}" href="{{link}}" style="background-image: url({{image}});"></div>'
    });

    feed.run();



    

$( window ).resize(function() {
 
  var insta = $('.single-instagram-post');
  var instaWidth = insta.width();
  insta.height(instaWidth);


 
});



});


  } catch(e) { console.error(e); }
})();
})();
